import React from 'react'
import { css } from 'emotion'

import AntTabs from 'antd/es/tabs'
import 'antd/es/tabs/style/css'

import { MAIN_FONT, FONT_SIZE } from 'src/shared/TypographyStyles'
import { useTheme } from 'src'

type Props = {
  activeKey?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: any
  animated?: boolean
  children: React.ReactNode
}

const Tabs = ({ children, ...rest }: Props) => {
  const { brand } = useTheme()
  const style = `
    font-family: ${MAIN_FONT};
    font-size: ${FONT_SIZE.P1};

    &.ant-tabs {
      width: 100%;
    }

    .ant-tabs-ink-bar {
      z-index: 0;
    }

    .ant-tabs-nav .ant-tabs-tab {
      margin-right: 20px;
      padding-top: 8px;
      padding-bottom: 8px;
    }

    .ant-tabs-nav .ant-tabs-tab-active,
    .ant-tabs-nav .ant-tabs-tab:hover,
    .ant-tabs-nav .ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${brand.primary.default};
    }
    
    .ant-tabs-ink-bar {
      background-color: ${brand.primary.default}; 
    }
    `

  return (
    <AntTabs className={`${css(style)}`} {...rest}>
      {children}
    </AntTabs>
  )
}

Tabs.TabPane = AntTabs.TabPane

export default Tabs
